const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  loading = false,
  onClick,
  type = 'button',
  form,
  className = '',
  ...restProps
}) => {
  const baseClasses = 'btn font-medium focus:outline-none transition-all duration-200';

  const variantClasses = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    success: 'btn-success',
    warning: 'btn-warning',
    error: 'btn-error',
    ghost: 'btn-ghost',
    link: 'btn-link'
  };

  const sizeClasses = {
    xs: 'btn-xs',
    sm: 'btn-sm',
    small: 'btn-sm',  // Backward compatibility
    md: '',
    medium: '',       // Backward compatibility
    lg: 'btn-lg',
    large: 'btn-lg',  // Backward compatibility
    xl: 'btn-xl'
  };

  return (
    <button
      type={type}
      form={form}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} rounded-lg ${className}`}
      {...restProps}
    >
      {loading ? (
        <span className="loading loading-spinner loading-sm" />
      ) : (
        children
      )}
    </button>
  );
};

export default Button;